import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaHistory } from "react-icons/fa";
import { SERVER_URL } from "../../config";
import { formatDateTime } from "./utils";

const getEmployeeId = () => {
    try {
        let userData = localStorage.getItem('employee');
        if (!userData) userData = localStorage.getItem('user');
        const user = JSON.parse(userData || '{}');
        return user.employee_id || '';
    } catch {
        return '';
    }
};

const SourceBadge = ({ source }) => (
    <span
        className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide ${
            source === "server" ? "bg-indigo-50 text-indigo-700 border border-indigo-200" : "bg-sky-50 text-sky-700 border border-sky-200"
        }`}
    >
        {source === "server" ? "Server" : "User"}
    </span>
);

const AdminLogsModal = ({ open, onClose, notify }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    const fetchLogs = () => {
        setLoading(true);
        axios
            .get(`${SERVER_URL}/Cloud/adminLogs.php`, {
                params: { employee_id: getEmployeeId(), search: search || undefined },
            })
            .then((res) => {
                if (res.data.success) {
                    setLogs(res.data.data || []);
                } else {
                    notify(res.data.message || "Failed to load activity log.", "error");
                }
            })
            .catch(() => notify("Could not load activity log.", "error"))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (open) fetchLogs();
    }, [open]);

    useEffect(() => {
        if (!open) return;
        const t = setTimeout(fetchLogs, 350);
        return () => clearTimeout(t);

    }, [search]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[85] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
            <div className="w-full max-w-3xl max-h-[88vh] rounded-xl bg-white border border-slate-200 flex flex-col overflow-hidden" style={{ boxShadow: "0 10px 30px rgba(0,0,0,0.15)" }}>
                <div className="flex items-center justify-between gap-3 flex-wrap px-6 py-4 border-b border-slate-100 shrink-0">
                    <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                        <FaHistory className="w-4 h-4 text-blue-600" /> Activity Log
                    </h2>
                    <div className="flex items-center gap-2">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search action, user, employee…"
                            className="w-64 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-xs"
                        />
                        <button onClick={onClose} className="text-slate-400 hover:text-slate-600 text-lg leading-none px-1">✕</button>
                    </div>
                </div>

                <div className="overflow-y-auto px-6 py-4 flex-1">
                    {loading && <p className="text-sm text-slate-400 text-center py-6">Loading activity log…</p>}

                    {!loading && logs.length === 0 && (
                        <p className="text-sm text-slate-400 text-center py-6">No activity recorded yet.</p>
                    )}

                    {!loading && logs.length > 0 && (
                        <ul className="divide-y divide-slate-100">
                            {logs.map((log, idx) => (
                                <li key={idx} className="py-3 flex items-start gap-3">
                                    <SourceBadge source={log.source} />
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm text-slate-700 break-words">{log.action}</p>
                                        <p className="text-[11px] text-slate-400 mt-0.5">
                                            by <span className="font-semibold text-slate-500">{log.action_taken_by || "System"}</span>
                                            {" · "}{formatDateTime(log.created_at)}
                                            {" · "}ref {log.ref}
                                        </p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminLogsModal;
